/**
 * Created by Administrator on 2017/7/13.
 */
import {TOGGLESIDER,LOGINGMODAL,LOGINSUBMIT,LOGINCLOSED} from "./actionTypes";

export const ToggleSider = (newState) => ({
    type: TOGGLESIDER,
    newState: newState
});

export const LoginModal = () => ({
    type: LOGINGMODAL
});

export const LoginSubmit = () => ({
    type: LOGINSUBMIT
});

export const LoginClosed = () => ({
    type: LOGINCLOSED
});



// WEBPACK FOOTER //
// ./src/Pages/home/actions.js